import styled from 'styled-components';
import { theme } from '../../styles/theme';
import { mq } from '../../styles/mq';

export const HeaderMenuContainer = styled.div<{ $isOpen: boolean }>`
  position: absolute;
  left: 0;
  width: 100%;
  border-bottom: 1px solid ${theme.colors.text};
  ${(props) => (props.$isOpen ? 'top: 6rem' : 'top: 0')};
  ${mq.smallOnly} {
    ${(props) => (props.$isOpen ? 'top: 5rem' : 'top: 0')};
  }
  transition: top 0.5s;
  height: 6rem;
  ${mq.smallOnly} {
    height: 5rem;
  }
  ${mq.large} {
    display: none;
  }
  background-color: ${theme.colors.background};
  overflow: hidden;
`;

export const Left = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  width: 6rem;
  height: 6rem;
  padding-left: 1rem;
  border-right: 1px solid ${theme.colors.text};
  cursor: pointer;
  ${mq.smallOnly} {
    width: 5rem;
    height: 5rem;
    padding-left: 0;
    padding-right: 0.8rem;
  }
  div {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 3rem;
    height: 3rem;
    background: ${theme.colors.text};
    border-radius: 50%;
    font-weight: 800;
    font-size: 2rem;
    color: ${theme.colors.background};

    &::after {
      position: absolute;
      left: -1rem;
      content: '';
      width: 4px;
      height: 4px;
      transform: rotate(45deg);
      border-bottom: 1px solid ${theme.colors.text};
      border-left: 1px solid ${theme.colors.text};
      ${mq.smallOnly} {
        left: auto;
        right: -1rem;
      }
    }
    ${mq.smallOnly} {
      width: 1.5rem;
      height: 1.5rem;
      font-size: 1.2rem;
    }
  }
`;

export const Right = styled.div`
  position: absolute;
  display: flex;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  right: 0;
  width: 6rem;
  height: 6rem;
  padding-right: 1rem;
  font-weight: 800;
  font-size: 2rem;
  border-left: 1px solid ${theme.colors.text};
  cursor: pointer;
  ${mq.smallOnly} {
    width: 5rem;
    height: 5rem;
    padding-right: 0;
    padding-left: 0.8rem;
  }
  div {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 3rem;
    height: 3rem;
    background: ${theme.colors.text};
    border-radius: 50%;
    color: ${theme.colors.background};
    &::after {
      position: absolute;
      right: -1rem;
      content: '';
      width: 4px;
      height: 4px;
      transform: rotate(45deg);
      border-top: 1px solid ${theme.colors.text};
      border-right: 1px solid ${theme.colors.text};
      ${mq.smallOnly} {
        right: auot;
        left: -1rem;
      }
    }
    ${mq.smallOnly} {
      width: 1.5rem;
      height: 1.5rem;
      font-size: 1.2rem;
    }
  }
`;

export const Center = styled.div`
  position: absolute;
  left: 6rem;
  right: 6rem;
  height: 6rem;
  overflow: hidden;
  ${mq.smallOnly} {
    left: 5rem;
    right: 5rem;
    height: 5rem;
  }
`;

export const Chapters = styled.div<{ $position: number }>`
  position: absolute;
  top: 0;
  left: 0;
  ${(props) => 'left: ' + (props.$position - 1) * -100 + '%'};
  width: 900%;
  height: 6rem;
  transition: left 0.5s;
  counter-reset: header;

  ${mq.smallOnly} {
    height: 5rem;
  }
`;

export const Chapter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% / 9);
  height: 100%;
  font-size: 1.7rem;
  font-weight: 800;
  counter-increment: header;
  float: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${mq.smallOnly} {
    font-size: 1.5rem;
  }
`;

export const ChapterWrapper = styled.div`
  text-align: left;
  width: max-content;
  max-width: 100%;
  padding: 0 1em;
  overflow: hidden;
  text-overflow: ellipsis;

  &::before {
    content: counter(header);
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    margin-right: 1rem;
    width: 2rem;
    height: 2rem;
    flex-shrink: 0;
    font-size: 1.5rem;
    background: ${theme.colors.orange};

    ${mq.smallOnly} {
      font-size: 1.2rem;
      width: 1.5rem;
      height: 1.5rem;
    }
  }
`;
